import React from 'react';
import '../../App.css';
import { Routes, Route } from 'react-router-dom';
import ProfileSidebar from './ProfileSidebar';
import ProfileDetails from './ProfileDetails';
import ProfileSecurity from './ProfileSecurity';
import CompanyProfile from './CompanyProfile';
import UserSessionManager from '../../utils/UserSessionManager';


const Profile = ({ activeTab = 'details' }) => {
  const userInfo = UserSessionManager.getUserInfo();

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      
      {/* Welcome message at top */}
      <div className="d-flex justify-content-between align-items-center px-4 py-2">
      <h4 className="mb-0">🎉 Welcome {userInfo.fullName}!</h4>
      <div className="subscription-info">
 {
            userInfo.activationPlan ? (
              <>
                Enrolled In: <strong>{userInfo.activationPlan}</strong>, Subscription expires on{" "}
                <span className="text-success fw-bold">
                  {new Date(userInfo.subscriptionEndDate).toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })}
                </span>
              </>
            ) : (
              'No active subscription plan'
            )
          }        </div>
      </div>

     {/* Layout starts here */}
      <div className="d-flex">
        <ProfileSidebar />
        <div className="px-4 py-0 flex-grow-1">
          <div className="dashboard-wrapper">
            <div className="page-header-tab">
              {activeTab === 'security'
                ? 'Profile Security'
                : activeTab === 'company'
                  ? 'Company Profile'
                  : 'Profile Details'}
            </div>
            <div className="dashboard-card">
              {activeTab === 'security' ? (
                <ProfileSecurity />
              ) : activeTab === 'company' ? (
                <CompanyProfile />
              ) : (
                <ProfileDetails />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
